import { render, staticRenderFns } from "./custConvertRealList.vue?vue&type=template&id=af8210b8&scoped=true"
import script from "./custConvertRealList.vue?vue&type=script&lang=js"
export * from "./custConvertRealList.vue?vue&type=script&lang=js"
import style0 from "./custConvertRealList.vue?vue&type=style&index=0&id=af8210b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8210b8",
  null
  
)

export default component.exports